import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingController, Platform, ToastController } from '@ionic/angular';
import { CookieService } from 'ngx-cookie-service';
import { BaseClass } from '../shared/classes/base';
import { AuthService } from '../shared/services/auth.service';
import { TranslationService } from '../shared/services/translation.service';
import { Credentials } from './interfaces/credentials.interface';
import { ConfigService } from '../shared/services/multi-clients/config.service';
import { AssetService } from '../shared/services/multi-clients/asset.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.page.html',
    styleUrls: ['./login.page.scss']
})
export class LoginComponent extends BaseClass implements OnInit {

    public loading: boolean;
    public formGroup: UntypedFormGroup;
    public apiUrl = '';
    public standardLogin = false;
    public sso ;
    public overrideLogin = false;
    public loginImgPath: string = '';

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        private _authService: AuthService,
        private router: Router,
        private _activatedRoute: ActivatedRoute,
        private _loadingController: LoadingController,
        private _cookieService: CookieService,
        public platform: Platform,
        private _configService: ConfigService,
        private _assetService: AssetService
    ) {
        super(_toastController, _translationService);
        
        this.formGroup = new UntypedFormGroup({
            'username': new UntypedFormControl('', [Validators.required]),
            'password': new UntypedFormControl('', [Validators.required])
        });
        if (this._authService.hasToken()) {
            this.router.navigate(['dashboard']);
        }

        this.overrideLogin = this._getQueryString('overrideLogin') === '1';
    }
    ngOnInit(): void {
        this.apiUrl = this._configService.settings.apiUrl;
        this.sso = this._configService.settings.features.sso;
        this.loginImgPath = this._assetService.getLoginImgPath();
    }

    public async forgotPass() {
        const credentials = this.formGroup.getRawValue();
        if (credentials.username) {
            this.loading = true;
            await this._authService.forgotPass(credentials.username).subscribe(() => {
                this.loading = false;
                this.notifySuccess('login.forgotPassSuccess');
            }, (error) => {
                this.loading = false;
                this.notifyError(error);
            });
        } else {
            this.notify('Preencha o campo de usúario', 'danger');
        }
    }

    public signUp() {
        this.router.navigate(['register']);
    }

    public async doLogin() {
        this.loading = true;
        const credentials: Credentials = this.formGroup.getRawValue();

        try {
            const result = await this._authService.login(credentials.username, credentials.password);
            result.success ?
                this._handleLoginSuccess(result) :
                this._handleLoginError(result);

        } catch (error) {
            this.notifyError(error);
            this.loading = false;
        }
    }

    public async loginOAuth() {
        const loading = await this._loadingController.create();
        loading.present();
        this._authService.loginOAuthSSO()
            .then(() => this.router.navigate(['dashboard']))
            .catch((err) => {
                this.notifyError(err);
            }).finally(() => {
                loading.dismiss();
            });
    }

    private _handleLoginSuccess(result): void {
        this.loading = false;
        if (result.data.passwordChangeRequired)
            this.router.navigate(['first-access'])
        else {
            if (this._authService.getRedirectUrl())
                this._goRedirectURl()
            else
                this.router.navigate(['dashboard']);
        }
    }

    private _goRedirectURl() {
        const url = this._authService.getRedirectUrl();
        this._authService.clearRedirectUrl();
        this.router.navigateByUrl(url);
    }

    private _handleLoginError(result): void {
        const error = result && result.errors && result.errors.length > 0 ?
            result.errors[0] : 'Houve um erro ao se comunicar com o servidor. Por favor tente mais tarde.';
        this.loading = false;
        this.notify(this._translationService.getTranslation(error), 'danger');
    }

    private _getQueryString(param: string): string | null {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }
}
